import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const province = z
    .union([
    z.literal("Alberta"),
    z.literal("British Columbia"),
    z.literal("Manitoba"),
    z.literal("New Brunswick"),
    z.literal("Newfoundland and Labrador"),
    z.literal("Northwest Territories"),
    z.literal("Nova Scotia"),
    z.literal("Nunavut"),
    z.literal("Ontario"),
    z.literal("Prince Edward Island"),
    z.literal("Quebec"),
    z.literal("Saskatchewan"),
    z.literal("Yukon"),
])
    .optional()
    .describe(createCustomSettings({
    dependsOn: { field: "Country", value: "Canada" },
    label: "Province",
}));
export const provinceLookup = {
    ab: "Alberta",
    bc: "British Columbia",
    "british-columbia": "British Columbia",
    "british columbia": "British Columbia",
    mb: "Manitoba",
    nb: "New Brunswick",
    "new brunswick": "New Brunswick",
    nl: "Newfoundland and Labrador",
    "northwest territories": "Northwest Territories",
    "nova scotia": "Nova Scotia",
    ns: "Nova Scotia",
    nt: "Northwest Territories",
    on: "Ontario",
    pe: "Prince Edward Island",
    qc: "Quebec",
    sk: "Saskatchewan",
    yt: "Yukon",
};
//# sourceMappingURL=province-list.js.map